import aboutimg from "../../../../assests/images/aboutimg.webp";
import BlogSection from "../../components/blog/blogsection";
import SectionLast from "../../components/sectionlast/SectionLast";

const investors = [
  { name: "Blockchain.com", icon: "◆" },
  { name: "GEMINI", icon: "⊕" },
  { name: "Lightspeed", icon: "▲" },
  { name: "AVON VENTURES", icon: null },
  { name: "MORGAN CREEK DIGITAL ASSETS", icon: null },
  { name: "POMP INVESTMENTS", icon: null },
  { name: "VELVET SEA VENTURES", icon: "≋" },
  { name: "PARAFI CAPITAL", icon: null },
];

const values = [
  {
    title: "Dedicated to delivering impact",
    body: "Element Us Labs is dedicated to a web3 that brings the most positive impact for the most people. We believe web3 has the potential to revolutionize our day-to-day lives in far-reaching ways that are yet unimaginable. We also recognize our responsibility as stewards of the technology to always endeavor to make blockchain a force for good.",
  },
  {
    title: "Remain focused and move fast",
    body: "Building the market's #1 data-driven blockchain intelligence platform is no easy feat—and we're in a race against time. To deliver on our mission, we carefully prioritize our efforts on the highest impact work and produce results with a high degree of urgency.",
  },
  {
    title: "Success is a collective effort",
    body: "Either we succeed as a team or we fail as individuals. Achieving peak performance requires trust, commitment, and accountability—and requires that we work as a cohesive unit. While everyone has the freedom to focus on their own contributions, it's imperative that we trust and respect each other, and deliver on what we commit in a timely way.",
  },
  {
    title: "Act like entrepreneurs",
    body: "Building a high-growth startup is extremely difficult and when something doesn't go our way (and most things do not) it can feel downright discouraging. Overcoming adversity requires tenacity, fortitude, creativity, and determination. Despite all of this, building a company is a special experience in life—and there's nothing more rewarding than solving hard problems with people you trust.",
  },
  {
    title: "Always lead with honesty, integrity, and mutual respect",
    body: "These core principles are non-negotiable for all current and future Elementites and stakeholders.",
  },
];

function DotGrid({ rows = 5, cols = 6, brightIndexes = [] }) {
  return (
    <div
      className="grid gap-2"
      style={{ gridTemplateColumns: `repeat(${cols}, 1.75rem)` }}
    >
      {Array.from({ length: rows * cols }).map((_, i) => (
        <div
          key={i}
          className={`w-7 h-7 rounded-full ${
            brightIndexes.includes(i)
              ? "bg-violet-600 opacity-100"
              : "bg-[#2d2458] opacity-80"
          }`}
        />
      ))}
    </div>
  );
}

export default function AboutPage() {
  return (
    <div>
      {/* ── HERO ── */}
      <section className="bg-[#100f1e]">
        <div className="pt-24 pb-8 lg:py-32 max-w-[1400px] mx-auto px-10">
          <h1
            style={{
              fontSize: "clamp(2.4rem, 6.5vw, 5.2rem)",
              fontWeight: 600,
              lineHeight: 1,
              color: "#fff",
              marginTop: 0,
              marginBottom: "clamp(28px, 4vw, 48px)",
              letterSpacing: "-0.03em",
            }}
          >
            Your data-first partner
            <br />
            in the{" "}
            <span className="text-violet-500 border-2 border-violet-500 rounded-full px-4 py-1 inline-block leading-tight">
              blockchain
            </span>
          </h1>

          {/* Image wrapper */}
          <div className="relative rounded-t-2xl overflow-visible">
            <div className="w-full h-56 sm:h-80 lg:h-[460px] rounded-t-2xl overflow-hidden bg-gradient-to-br from-gray-300 via-gray-200 to-gray-300 flex items-center justify-center">
              <img
                src={aboutimg}
                alt="About Elementus"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Dot grid - bottom right of image */}
            <div className="absolute -bottom-5 right-8 sm:right-14 z-10 hidden lg:block">
              <div
                className="grid gap-2"
                style={{ gridTemplateColumns: "repeat(6, 1.1rem)" }}
              >
                {Array.from({ length: 30 }).map((_, i) => (
                  <div
                    key={i}
                    className={`w-[1.1rem] h-[1.1rem] rounded-full ${
                      i === 14 ? "bg-violet-600" : "bg-[#3d2e6e] opacity-70"
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── OUR VISION ── */}
      <section className="bg-[#100f1e] px-5 sm:px-10 lg:px-16 py-20 sm:py-28 relative overflow-hidden">
        {/* Dot decoration top-right */}
        <div className="absolute top-6 right-0 pr-3 sm:pr-8 pt-4 hidden md:block z-0">
          <DotGrid rows={5} cols={6} brightIndexes={[8, 14, 15]} />
        </div>

        {/* Text content */}
        <div className="relative z-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-10 sm:mb-14">
            Our vision
          </h2>

          <p className="text-lg sm:text-xl leading-relaxed text-[#d1d0e8] max-w-[520px] md:ml-28 lg:ml-40">
            Element Us Labs believes the democratization of blockchain data and
            technology is the key to breeding new innovations that transform
            industries and lives.
          </p>
        </div>
      </section>

      {/* ── OUR VALUES ── */}
      <section className="bg-white text-[#0f0e1a] py-20 sm:py-28">
        {/* Header — has its own padding */}
        <div className="px-5 sm:px-10 lg:px-16 flex flex-col lg:flex-row lg:justify-between lg:items-start gap-6 lg:gap-20 mb-16 sm:mb-20">
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-[#0f0e1a] shrink-0 leading-tight">
            Our values
          </h2>
          <p className="text-2xl sm:text-3xl text-violet-600 font-normal leading-snug max-w-xl">
            Our values serve as a system of guiding principles and core tenets
            that shape the behaviors we exhibit, and frame the decisions we make
            as a team.
          </p>
        </div>

        {/* Content wrapper — same padding, border starts here */}
        <div className="w-full lg:max-w-[1200px] px-16 ms-auto">
          {/* Divider — starts at content edge */}
          <div className="border-t border-gray-800" />

          {/* Grid — horizontal borders between rows, no vertical divider */}
          <div className="grid grid-cols-1 lg:grid-cols-2 border-t border-gray-700">
            {/* Row 1 */}
            <div className="lg:pr-16 py-10 border-b border-gray-800">
              <h3 className="text-lg sm:text-xl font-bold text-[#0f0e1a] mb-5 leading-snug">
                {values[0].title}
              </h3>
              <p className="text-sm sm:text-base text-gray-500 leading-relaxed">
                {values[0].body}
              </p>
            </div>
            <div className="lg:pl-16 py-10 border-b border-gray-800">
              <h3 className="text-lg sm:text-xl font-bold text-[#0f0e1a] mb-5 leading-snug">
                {values[1].title}
              </h3>
              <p className="text-sm sm:text-base text-gray-500 leading-relaxed">
                {values[1].body}
              </p>
            </div>

            {/* Row 2 */}
            <div className="lg:pr-16 py-10 border-b border-gray-800">
              <h3 className="text-lg sm:text-xl font-bold text-[#0f0e1a] mb-5 leading-snug">
                {values[2].title}
              </h3>
              <p className="text-sm sm:text-base text-gray-500 leading-relaxed">
                {values[2].body}
              </p>
            </div>
            <div className="lg:pl-16 py-10 border-b border-gray-800">
              <h3 className="text-lg sm:text-xl font-bold text-[#0f0e1a] mb-5 leading-snug">
                {values[3].title}
              </h3>
              <p className="text-sm sm:text-base text-gray-500 leading-relaxed">
                {values[3].body}
              </p>
            </div>

            {/* Row 3 — full width */}
            <div className="col-span-1 lg:col-span-2 py-10 border-b border-gray-300">
              <h3 className="text-lg sm:text-xl font-bold text-[#0f0e1a] mb-5 leading-snug">
                {values[4].title}
              </h3>
              <p className="text-sm sm:text-base text-gray-500 leading-relaxed max-w-xl">
                {values[4].body}
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* ── OUR INVESTORS ── */}
      <section className="bg-[#100f1e] px-5 sm:px-10 lg:px-16 py-20 sm:py-28">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-6 lg:gap-20 mb-14 sm:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white shrink-0">
            Our investors
          </h2>
          <p className="text-2xl sm:text-3xl lg:text-[2.5rem] font-normal text-white max-w-md leading-snug">
            Backed by the leading minds, innovators and influencers in web3 and
            technology.
          </p>
        </div>

        {/* Row 1 — 5 cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 justify-items-center gap-3">
          {investors.slice(0, 5).map((inv, i) => (
            <div className="bg-white rounded-xl px-4 py-6 sm:py-7 flex items-center justify-center gap-2 min-h-[80px] sm:min-h-[88px] w-full ">
              {inv.icon && (
                <span className="text-gray-700 text-base sm:text-lg shrink-0">
                  {inv.icon}
                </span>
              )}
              <span className="text-[10px] sm:text-xs font-bold text-[#0f0e1a] text-center tracking-wide leading-snug">
                {inv.name}
              </span>
            </div>
          ))}
        </div>

        {/* Row 2 — 3 cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 justify-center gap-3 mt-3">
          {investors.slice(5, 8).map((inv, i) => (
            <div
              key={i}
              className="bg-white rounded-xl px-4 py-6 sm:py-7 flex items-center justify-center gap-2 min-h-[80px] sm:min-h-[88px]"
            >
              {inv.icon && (
                <span className="text-gray-700 text-base sm:text-lg shrink-0">
                  {inv.icon}
                </span>
              )}
              <span className="text-[10px] sm:text-xs font-bold text-[#0f0e1a] text-center tracking-wide leading-snug">
                {inv.name}
              </span>
            </div>
          ))}
          {/* Invisible placeholders to preserve 5-col alignment on large screens */}
          <div className="hidden lg:block" />
          <div className="hidden lg:block" />
        </div>
      </section>

      <BlogSection />
      <SectionLast heading={"Get started with Elementus"} />
    </div>
  );
}
